import { SET_SOCIALS_FILTERS } from "../actions/filters";
import { CHANNEL_TYPE, PUBLICATION_TYPE, STATUS_TYPE } from "../helpers/types";

const INITIAL_STATE = {
  channel: CHANNEL_TYPE.FACEBOOK,
  type: STATUS_TYPE.PUBLISHED,
  typeOfSocial: PUBLICATION_TYPE.FEED,
};

const FiltersState = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_SOCIALS_FILTERS: {
      return {
        ...state,
        ...action.payload.filters,
      };
    }

    default:
      return state;
  }
};

export default FiltersState;
